module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Move_Light Gray.b4a8a080.svg";